import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Navigation } from "app/core/navigation/navigation.types";
import { catchError, Observable, of, ReplaySubject, tap } from "rxjs";
import {
  compactNavigation,
  defaultNavigation,
  futuristicNavigation,
  horizontalNavigation,
} from "app/mock-api/common/navigation/data";
import { FuseNavigationItem } from "@fuse/components/navigation";
import { compact } from "lodash";

@Injectable({ providedIn: "root" })
export class NavigationService {
  private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
  private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
  private readonly _futuristicNavigation: FuseNavigationItem[] =
    futuristicNavigation;
  private readonly _horizontalNavigation: FuseNavigationItem[] =
    horizontalNavigation;
  private _httpClient = inject(HttpClient);
  private _navigation: ReplaySubject<Navigation> =
    new ReplaySubject<Navigation>(1);

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for navigation
   */
  get navigation$(): Observable<Navigation> {
    return this._navigation.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get all navigation data
   */
  get(): Observable<Navigation> {
    return this._httpClient.get<Navigation>("api/common/navigation").pipe(
      catchError(() =>
        // Return false
        of({
          compact: this._compactNavigation,
          default: this._defaultNavigation,
          futuristic: this._futuristicNavigation,
          horizontal: this._horizontalNavigation
        })
      ),
      tap((navigation) => {
        this._navigation.next(navigation);
      })
    );
  }
}
